export default class EmailTemplate {
    "companyId": number;
    "emailTemplateId": number;
    "messageOptoutTypeId": number;
    "sendGridTemplateId": string = "";
    "name": string = "";
    "subject": string = "";
    "template": string = "";
}